"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _SourceListImageFileItemBody = require("./SourceListImageFileItemBody.styled");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PDF = require("../PDF");
require("react-pdf/dist/Page/AnnotationLayer.css");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var SourceListPdfFileItemBody = function SourceListPdfFileItemBody(_ref) {
  var value = _ref.value,
    onPresentationLoadSuccess = _ref.onPresentationLoadSuccess;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isDocumentLoaded = _useState2[0],
    setDocumentLoaded = _useState2[1];
  var url = value.url;
  var onDocumentLoad = function onDocumentLoad() {
    var pdf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      numPages: 0
    };
    var numPages = pdf.numPages;
    if (numPages > 0) {
      onPresentationLoadSuccess(pdf);
    }
    setDocumentLoaded(true);
  };
  return /*#__PURE__*/_react["default"].createElement(_SourceListImageFileItemBody.ImageViewer, null, /*#__PURE__*/_react["default"].createElement(_PDF.StudioPDFDocument, {
    onLoadSuccess: onDocumentLoad,
    key: url,
    file: url,
    className: "document"
  }, isDocumentLoaded && /*#__PURE__*/_react["default"].createElement(_PDF.StudioPDFPage, {
    pageNumber: 1,
    height: 110,
    className: "page",
    canvasBackground: "#ffffff"
  })));
};
SourceListPdfFileItemBody.propTypes = {
  value: _propTypes["default"].shape({
    url: _propTypes["default"].string
  }),
  onPresentationLoadSuccess: _propTypes["default"].func
};
var _default = exports["default"] = SourceListPdfFileItemBody;